// store
import UnderlyingChartsStore from './store';
import { UnderlyingChartsItem } from './typings';

class UnderlyingChartsService extends UnderlyingChartsStore {
  public toggleUnderlyingCharts = () => {
    this.setIsUnderlyingChartsChecked(!this.isUnderlyingChartsChecked);
  };

  public addUnderlyingChart = (underlyingChart: UnderlyingChartsItem) => {
    const updatedUnderlyingChartsList = [...this.underlyingChartsList];
    const existingUnderlyingChartIndex = this.underlyingChartsList.findIndex(
      chart => chart.chartIndex === underlyingChart.chartIndex,
    );
    if (existingUnderlyingChartIndex !== -1) {
      updatedUnderlyingChartsList.splice(existingUnderlyingChartIndex, 1);
    }

    updatedUnderlyingChartsList.push(underlyingChart);
    updatedUnderlyingChartsList.sort((a, b) => a.chartIndex - b.chartIndex);

    this.setUnderlyingChartsList(updatedUnderlyingChartsList);
  };

  public removeUnderlyingChart = (
    exchangeToken: string,
    chartIndex: number,
  ) => {
    const updatedUnderlyingChartsList =
      this.underlyingChartsList.filter(
        chart => chart.exchangeToken !== exchangeToken ||
          chart.chartIndex !== chartIndex,
      );
    this.setUnderlyingChartsList(updatedUnderlyingChartsList);
  };

  public clearUnderlyingChartsList = () => {
    this.setUnderlyingChartsList([]);
  };

  public getExistingUnderlyingChartsForExchangeToken = (
    exchangeToken: string,
    chartIndex: number,
  ) => this.underlyingChartsList.find(
      chart =>
        chart.exchangeToken === exchangeToken &&
        chart.chartIndex === chartIndex,
    );

  public getExistingUnderlyingChartsAtIndex = (
    chartIndex: number,
  ) => this.underlyingChartsList.find(
      chart =>
        chart.chartIndex === chartIndex,
    );
}

export default new UnderlyingChartsService();
